import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { LoginUser, SendOTP } from "../../../ApiServices/Login/Login";
// import { AuthContextProvider } from "../../../AuthContext/AuthContext";
// import "./Login.css";
// import { ERROR_MESSAGES } from "../../../Components/GlobalErrorMessage";
import Logo from "../assets/images/new/logo.png";
import Select from "react-select";
// import { countrySelect } from "../../../middlewares/Utils";
// import LoginImg from "../../../assets/images/new/AbuotUs.png";
import { SendOTP, VerifyOTP } from "../ApiServices/Login/Login";
import { AuthContextProvider, LoaderContext } from "../AuthContext/AuthContext";
import { ERROR_MESSAGES } from "./GlobalErrorMessage";
import { countrySelect, customSelectStyles } from "../middlewares/Utils";
import OTPInput from "otp-input-react";
import LoginOTPPopUp from "./LoginOTPPopup";

function LoginPopUp({ show, onHide, onConfirm, setOnGetOTP }) {
  const navigate = useNavigate();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showLoginOTPPopUp, setShowLoginOTPPopUp] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [error, setError] = useState(false);
  const [userID, setUserId] = useState();
  const [counter, setCounter] = useState(60);
  const [resendVisible, setResendVisible] = useState(false);
  const [timer, setTimer] = useState(60);
  const [otpLoader, setOtpLoader] = useState(null);
  const [loginObj, setLoginObj] = useState({
    username: "",
    email: "",
    countryID: 1,
    Latitude: null,
    Longitude: null,
    mobileNo: null,
  });
  const [loginOTPData, setLoginOTPData] = useState({
    Email: null,
    otp: null,
    MobileNo: null,
    UserName: null,
    CuntryID: null,

    Type: "SignIn",
  });
  const { setIsAuthenticated } = useContext(AuthContextProvider);
  const { setLoader } = useContext(LoaderContext);
  const [incorrectCred, setIncorrectCred] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [refCode, setRefCode] = useState(null);
  const [inviteFrom, setInviteFrom] = useState(null);
  useEffect(() => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoginObj((prevData) => ({
            ...prevData,
            Latitude: position.coords.latitude,
            Longitude: position.coords.longitude,
          }));
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
    const params = new URLSearchParams(window.location.search);
    const refCode = params.get("RefCode");
    const from = params.get("From");

    console.log('refCode=', refCode, 'from=', from)
    if (refCode) {
      setRefCode(refCode);
      localStorage.setItem("referralCode", refCode);
    }

    if (from) {
      setInviteFrom(from);
      localStorage.setItem("referralFrom", from);
    }
  }, []);



  const LoginData = () => {
    // debugger;
    let isValid = false;
    if (
      loginObj.username === "" ||
      loginObj.username === null ||
      loginObj.username === undefined ||
      loginObj.email === "" ||
      loginObj.email === null ||
      loginObj.email === undefined ||
      loginObj.mobileNo === "" ||
      loginObj.mobileNo === null ||
      loginObj.mobileNo === undefined ||
      loginObj.countryID === "" ||
      loginObj.countryID === null ||
      loginObj.countryID === undefined
    ) {
      isValid = true;
      setError(true);
    } else if (loginObj.email !== null && !validateEmail(loginObj.email)) {
      isValid = true;
      setError(true);
    } else if (loginObj?.mobileNo?.length !== 10) {
      isValid = true;
      setError(true);
    }

    const apiParams = {
      UserName: loginObj.username,
      MobileNo: loginObj.mobileNo,
      Email: loginObj.email,
      CuntryID: loginObj.countryID,
      Latitude: loginObj.Latitude,
      Longitude: loginObj.Longitude,
      Type: "SignIn",
      ApplicationType: 'Website',
      ReferredByUserCode: refCode,
      InviteFrom: inviteFrom
    };

    if (!isValid) {
      RegisterUserData(apiParams);
      setOtpLoader(false);
      // setOnGetOTP(false);
      // setShowLoginOTPPopUp(true);
      // setCounter(60); // Restart timer
      // navigate("/loginotp", {
      //   state: {
      //     mobileNumber: loginObj?.mobileNo,
      //     username: loginObj.username,
      //     email: loginObj.email,
      //     countryID: loginObj.countryID,
      //   },
      // });
    }
  };

  const RegisterUserData = async (apiParams) => {

    setLoader(true);
    setOtpLoader(true);
    const RegisterUserRes = await SendOTP(apiParams);

    try {
      if (RegisterUserRes?.ResponseMessage == "Success...") {
        setLoader(false);
        setOtpLoader(false);
        setShowLoginOTPPopUp(true);
        setCounter(60);
        // setTimeout(() => {
        //   navigate("/loginotp", {
        //     state: { mobileNumber: loginObj?.mobileNo },
        //   });
        // }, 100);
        // navigate("/loginotp", { state: { email: loginObj?.email } });
      } else {
        setLoader(false);
        setOtpLoader(false);
        setApiError(RegisterUserRes.ResponseMessage); // Set API error if not successful
      }
    } catch (error) {
      setLoader(false);
      setOtpLoader(false);
      console.log(error);
    }
  };

  const HandleCountryChange = (selectedValue) => {
    setLoginObj((prev) => ({
      ...prev,
      countryID: selectedValue.value,
    }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
    } else {
      setResendVisible(true);
    }

    return () => clearInterval(timer); // Cleanup timer on unmount
  }, [counter]);

  const handleOTPSubmit = async () => {
    // debugger;
    let isValid = false;

    if (!loginObj.mobileNo) {
      setErrorMessage("Email not found. Please try signing up again.");
      return;
    }

    if (!loginOTPData.otp) {
      isValid = true;
      setError(true);
    }

    if (!isValid) {
      setLoader(true)
      try {
        const response = await VerifyOTP(loginOTPData?.otp, loginObj.mobileNo);

        if (
          response.ResponseCode === "0" &&
          response.ResponseMessage === "Login successful!"
        ) {
          setLoader(false)
          localStorage.setItem("userID", response.DATA[0].UserID);
          localStorage.setItem("referralID", response.DATA[0]?.ReferalCode); // save full user info
          setIsAuthenticated(true);
          setErrorMessage(
            response.ResponseMessage || "Invalid OTP. Please try again."
          );
          onHide()
        } else {
          setLoader(false)
        }
      } catch (error) {
        setLoader(false)
        console.log(error);
      }
    }
  };

  const handleResendOTP = async () => {

    console.log("hello"); // Log "hello" on clicking resend
    const apiParams = {
      UserName: loginObj.username,
      MobileNo: loginObj.mobileNo,
      Email: loginObj.email,
      CuntryID: loginObj.countryID,
      Latitude: loginObj.Latitude,
      Longitude: loginObj.Longitude,
      Type: "SignIn",
    };
    const RegisterUserRes = await SendOTP(apiParams);

    try {
      if (RegisterUserRes?.ResponseMessage == "Success...") {
        // setLoader(false);

        setCounter(60); // Restart timer
        setResendVisible(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setInitialData = () => {
    setLoginObj(() => ({
      username: null,
      email: null,
      countryID: 1,
      mobileNo: null,
    }));
    setCounter(60)
  };
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        setError(false);
        setShowLoginOTPPopUp(false);
        setInitialData();
      }}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="custom-modal-width"
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">
          <span style={{ fontSize: "20px", fontWeight: "400" }}>
            {!showLoginOTPPopUp ? "Login" : "Verify OTP"}
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          color: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          maxHeight: "calc(100vh - 100px)",
          overflowY: "auto",
          padding: "10px 20px",
        }}
      >
        {!showLoginOTPPopUp ? (
          <div
            className="form-container sign-in-container"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "100%" }}>
              <div className="my-img text-center mb-3">
                <img
                  src={Logo}
                  alt="login otp"
                  className="img-fluid"
                  style={{ maxWidth: "150px", width: "100%", height: "auto" }}
                />
              </div>

              <input
                type="text"
                name="name"
                className="custom-form-control  mb-2"
                placeholder="Full Name"
                onChange={(e) => {
                  setError(false);
                  let inputVal = e.target.value.trimStart().replace(/[^A-Za-z\s]/g, "");
                  setLoginObj((prev) => ({
                    ...prev,
                    username: inputVal,
                  }));
                }}
                value={loginObj.username}
                maxLength={30}
              />
              {error && !loginObj.username?.trim() && (
                <span className="error-msg text-danger d-block mb-2">{ERROR_MESSAGES}</span>
              )}

              <input
                type="text"
                name="email"
                className="custom-form-control  mb-2"
                placeholder="Email"
                onChange={(e) => {
                  setError(false);
                  let inputVal = e.target.value.trimStart();
                  setLoginObj((prev) => ({
                    ...prev,
                    email: inputVal,
                  }));
                }}
                value={loginObj.email}
                maxLength={50}
              />
              {error &&
                (!loginObj.email?.trim() ? (
                  <span className="error-msg text-danger d-block mb-2">{ERROR_MESSAGES}</span>
                ) : !validateEmail(loginObj.email) ? (
                  <span className="error-msg text-danger d-block mb-2">Invalid Email ID</span>
                ) : null)}

              <div className="d-flex align-items-center mb-2" style={{ gap: "8px" }}>
                <div style={{ width: "30%", minWidth: "75px" }}>
                  <Select
                    options={countrySelect}
                    value={countrySelect.find((val) => val.value === loginObj.countryID)}
                    placeholder="+91"
                    onChange={HandleCountryChange}
                    styles={customSelectStyles}
                  />
                </div>
                <input
                  type="text"
                  name="mobile"
                  className="custom-form-control "
                  placeholder="Mobile Number"
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, "");
                    setLoginObj((prev) => ({
                      ...prev,
                      mobileNo: numericValue,
                    }));
                  }}
                  value={loginObj.mobileNo}
                  maxLength={10}
                  style={{ flex: 1 }}
                />
              </div>
              {error &&
                (!loginObj.mobileNo?.trim() ? (
                  <span className="error-msg text-danger d-block mb-2">{ERROR_MESSAGES}</span>
                ) : loginObj.mobileNo?.length !== 10 ? (
                  <span className="error-msg text-danger d-block mb-2">Invalid Mobile Number</span>
                ) : null)}

              {apiError && (
                <span className="text-danger d-block mb-2" style={{ fontSize: "14px" }}>
                  {apiError}
                </span>
              )}
            </div>
          </div>
        ) : (
          <div
            className="form-container sign-in-container"
            style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}
          >
            <div className="my-img mb-3 text-center">
              <img
                src={Logo}
                alt="otp img"
                className="img-fluid"
                style={{ maxWidth: "150px", width: "100%" }}
              />
            </div>
            <h4 className="mb-2">Enter OTP</h4>
            <span className="mb-3" style={{ fontSize: "15px" }}>
              Please enter the OTP sent to your mobile number{" "}
              {loginObj.countryID === 1 ? "+91 " : "+44 "}
              {loginObj.mobileNo}
            </span>

            <OTPInput
              value={loginOTPData.otp}
              className="otp-input"
              onChange={(otp) => {
                setError(false);
                setLoginOTPData((prev) => ({
                  ...prev,
                  otp,
                }));
              }}
              autoFocus
              OTPLength={4}
              otpType="number"
              disabled={false}
            />

            {error && errorMessage && (
              <span className="text-danger mt-2" style={{ fontSize: "14px" }}>
                {errorMessage}
              </span>
            )}

            <div className="mt-3">
              {resendVisible ? (
                <button
                  className="resend-btn btn btn-link text-danger p-0"
                  onClick={handleResendOTP}
                >
                  Resend OTP
                </button>
              ) : (
                <span style={{ fontSize: "13px", color: "#666" }}>
                  Resend OTP in {counter}s
                </span>
              )}
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: "center" }}>
        {!showLoginOTPPopUp ? (
          <button
            type="submit"
            className=" Normal-app-btn w-100"
            disabled={otpLoader}
            onClick={LoginData}
            style={{ maxWidth: "250px", fontSize: "14px" }}
          >
            {otpLoader ? <div className="small-loader"></div> : "Get OTP"}
          </button>
        ) : (
          <button
            type="submit"
            className=" Normal-app-btn w-100"
            onClick={handleOTPSubmit}
            style={{ maxWidth: "250px", fontSize: "14px" }}
          >
            Verify OTP
          </button>
        )}
      </Modal.Footer>
    </Modal>

  );
}

export default LoginPopUp;
